import { QuestionCircleOutlined, WarningOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { PROPERTY_TAB_KEYS } from '../../../common/propertyDetailTypes'
import {
  COVERAGE_INTENSITY,
  RentCoverage,
} from '../../../common/propertyPriceTypes'
import { clickTrigger } from '../../utils/layoutConst'
import { PropertyDetailLink } from '../PropertyDetailLink/PropertyDetailLink'

export interface PropertyDetailSidebarPriceUnitCoverageProps {
  rentCoverage?: RentCoverage | 0
  saleCoverage?: number
  noArea?: boolean
  propertyId?: string
}

export const PropertyDetailSidebarPriceUnitCoverage: FunctionComponent<PropertyDetailSidebarPriceUnitCoverageProps> =
  ({ rentCoverage, saleCoverage, noArea, propertyId }) => {
    const coverageText = useMemo(() => {
      if (!rentCoverage && !saleCoverage && !noArea)
        return 'Pro tuto lokalitu nemáme dostatek dat k určení ceny.'

      const extraWord =
        (typeof saleCoverage === 'number' && saleCoverage < 50) ||
        (typeof rentCoverage === 'number' && rentCoverage < 3)
          ? 'pouze '
          : ''

      const count = rentCoverage
        ? COVERAGE_INTENSITY[rentCoverage]
        : saleCoverage

      if (noArea)
        return (
          <div>
            Bez uvedené výměry bytu je zobrazená částka pouze orientační s
            odchylkou +/- 20 %. <br />
            Pro přesnější výpočet přejděte na kartu{' '}
            <PropertyDetailLink
              text="Cenové údaje"
              propertyId={propertyId}
              tab={PROPERTY_TAB_KEYS.PRICE}
              propertyType={PROPERTY_TYPES.UNIT}
            />
            .
          </div>
        )

      return `Datová pokrytost ${extraWord}${count} vzorků`
    }, [noArea, propertyId, rentCoverage, saleCoverage])

    const icon = useMemo(() => {
      if (noArea) return <WarningOutlined className="text-red-400" />

      if (rentCoverage === 2)
        return <QuestionCircleOutlined className="text-yellow-800" />
      if (rentCoverage === 1)
        return <WarningOutlined className="text-red-400" />

      if (saleCoverage && saleCoverage < 5)
        return <WarningOutlined className="text-red-400" />
      if (saleCoverage && saleCoverage < 25)
        return <WarningOutlined className="text-yellow-600" />
      if (saleCoverage && saleCoverage < 50)
        return <QuestionCircleOutlined className="text-yellow-800" />

      return <QuestionCircleOutlined className="text-gray-400" />
    }, [noArea, rentCoverage, saleCoverage])

    return (
      <Tooltip
        title={coverageText}
        placement="topRight"
        className="cursor-help"
        trigger={clickTrigger}
      >
        <div className="hover:opacity-80">{icon}</div>
      </Tooltip>
    )
  }
